import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kp_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const resolveMedia = (url) => (url?.startsWith("/api/") ? `${BACKEND_URL}${url}` : url);

export const getToken = () => localStorage.getItem("kp_admin_token");
export const setToken = (t) => {
  t ? localStorage.setItem("kp_admin_token", t) : localStorage.removeItem("kp_admin_token");
  window.dispatchEvent(new Event("kp:auth"));
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(" ");
  const st = e?.response?.status;
  if (st === 413) return "The server rejected the request as too large (HTTP 413). If this is your published site, re-publish the app so it gets the new piece-by-piece uploader, then try again.";
  if (st >= 500) return `Server error (${st}) while saving the file. Please retry in a moment; if it keeps happening, contact support with this code.`;
  if (st === 401) return "Session expired — please log in again.";
  if (st === 504 || e?.code === "ECONNABORTED") return "Upload timed out. Check your connection and try again.";
  if (e?.message === "Network Error") return "Connection lost during upload. Please check your internet and retry.";
  return e?.message || "Something went wrong";
};
